export const GET_QUADRANT_REPORT_SEASONS = /* GraphQL */ `
  query GetLearningRateQuadrantReportSeasons {
    getLearningRateQuadrantReportSeasons {
      seasonName
      seasonYear
    }
  }
`;
